import { render, staticRenderFns } from "./FilterChip.vue?vue&type=template&id=700d3f2e"
import script from "./FilterChip.vue?vue&type=script&lang=js"
export * from "./FilterChip.vue?vue&type=script&lang=js"
import style0 from "./FilterChip.vue?vue&type=style&index=0&id=700d3f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports